// Default no-image placeholder as a data URL (gray box with "No Image" text)
export const NO_IMAGE_PLACEHOLDER = 'data:image/svg+xml;base64,' + btoa(`
  <svg width="400" height="300" viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#f3f4f6"/>
    <g opacity="0.5">
      <rect x="140" y="110" width="120" height="80" rx="4" fill="#9ca3af"/>
      <circle cx="170" cy="140" r="12" fill="#f3f4f6"/>
      <path d="M140 170 L180 140 L220 160 L260 130 L260 190 L140 190 Z" fill="#d1d5db"/>
    </g>
    <text x="200" y="220" font-family="Arial, sans-serif" font-size="16" fill="#6b7280" text-anchor="middle">
      No Image Available
    </text>
  </svg>
`);

// Alternative: You can use a static image URL if you have one hosted
// export const NO_IMAGE_PLACEHOLDER = '/assets/no-image.png';